import {Trans, useTranslation} from 'react-i18next';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import {Field} from 'formik';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Select from 'react-select';
import langUtils from '../../../../../utils/langUtils';
import {scoreRanges} from '../../../../../utils/skincareUtils';
import TextareaBox from '../../../../../components/formik/TextareaBox';
import Section from '../../layout/Section';
import React from 'react';

export default function DetectionSummary({formikProps}) {
  const {t} = useTranslation();
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.detection.summary">
          Detection Summary
        </Trans>
      }
    >
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.skin.summary">
            Show Skin Summary
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.summary.show"
          value={_get(formikProps.values, 'skinResultPage.skinReport.summary.show')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.select.editing.language">
            Select Editing Language
          </Trans>
        }
      >
        <Select
          options={langUtils.getAppLangList()}
          onChange={o => {
            formikProps.setFieldValue(
              'skinResultPage.skinReport.summary.description.textLanguage',
              o
            );
          }}
          value={_get(
            formikProps.values,
            'skinResultPage.skinReport.summary.description.textLanguage',
            {label: 'English', value: 'enu'}
          )}
          isSearchable={false}
          isClearable={false}
          placeholder={
            <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
          }
        />
      </LeftTitleWithField>
      {scoreRanges(2).map(range => (
        <div key={range.value}>
          <LeftTitleWithField title={range.label}>
            <div style={{width: '100%'}}>
              <Field
                name={`skinResultPage.skinReport.summary.description.${_get(
                  formikProps.values,
                  'skinResultPage.skinReport.summary.description.textLanguage.value',
                  'enu'
                )}.${range.key}`}
                component={TextareaBox}
                style={{width: '100%'}}
                placeholder={t('c.f.text.up.character', {
                  defaultValue: 'Up to {{maxNum}} characters recommended.',
                  maxNum: 400,
                })}
              />
            </div>
          </LeftTitleWithField>
        </div>
      ))}
    </Section>
  );
}
